import { v4 as uuidv4 } from 'uuid';

import { consentTelemetry } from '../api';
import { logError } from '../log';
import { isAndroid, isCordova, isIOS } from '../mobile/deviceDetection';

let promptId = null;

/** Starts a new banner impression; links `shown` to the decision. */
export const newPrompt = () => {
  promptId = uuidv4();
  return promptId;
};

const platform = () => (isCordova() ? (isIOS() ? 'ios' : isAndroid() ? 'android' : 'web') : 'web');

/**
 * Fire-and-forget consent telemetry. Never awaited, never throws.
 * @param {'shown'|'accept_all'|'custom'|'necessary_only'} action
 * @param {{statistics?: boolean, marketing?: boolean}} categories
 * @param {string} [locale]
 */
export const sendConsentTelemetry = (action, { statistics = null, marketing = null } = {}, locale) => {
  try {
    if (typeof window === 'undefined') return;
    // Decisions made via the footer "Cookie settings" link never went through
    // the banner (which is what calls newPrompt), so promptId would be null and
    // the change — including a withdrawal — would be silently dropped. Mint one.
    if (!promptId) newPrompt();
    consentTelemetry({
      promptId,
      action,
      statistics,
      marketing,
      platform: platform(),
      locale,
    }).catch(() => {});
  } catch (e) {
    logError(e, 'consent-telemetry');
  }
};
